<div class="card search-card h-100">
    <div class="card-body">
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon3">{{ label() }}</span>
            </div>
            <input 
                type="text" 
                [class]="inputClass()" 
                [placeholder]="effectivePlaceholder()" 
                [ngModel]="currentSearchValue()"
                (ngModelChange)="currentSearchValue.set($event)">
            <div class="input-group-append">
                <button 
                    matButton="outlined" 
                    class="px-1"
                    (click)="onUpdateSearch()"
                    [disabled]="!hasSearchValue()">
                    <mat-icon class="material-icons-outlined">search</mat-icon>
                </button>
                <button 
                    matButton="outlined" 
                    class="px-1"
                    (click)="onClearSearch()"
                    [disabled]="!hasActiveSearch()">
                    <mat-icon class="material-icons-outlined">close</mat-icon>
                </button>
            </div>
        </div>
        <!-- Debug info -->
        <!-- <div class="mt-2 small text-muted">
            Debug: currentSearchValue = "{{ currentSearchValue() }}", hasSearchValue = {{ hasSearchValue() }}
        </div> -->
    </div>
    @if(showSearchFooter()) {
        <div class="card-footer card-current-search d-flex justify-content-center">
            Current Search: {{ searchTerm().currentSearchValue | json }}
        </div>
    }
</div>


